import $ from 'jquery';

global.$ = global.jQuery = $;

require('ion-rangeslider');
require('air-datepicker');

export default () => {
  /* Header hamburger */
  $(".hamburger_box").click(function () {
    $(this).toggleClass("open");
    $('.nav_wrapper').slideToggle("fast");
  });

  $(".month_wrapper .field").click(() => {
    $('.month_wrapper .field_dropdown').toggleClass("open");
  });
  $(document).click((event) => {
    if (!$(event.target).closest('.month_wrapper .field_dropdown').length && !$(event.target).closest('.month_wrapper .field').length) {
      if ($('.month_wrapper .field_dropdown').is(":visible")) {
        $('.month_wrapper .field_dropdown').removeClass('open');
      }
    }
  });

  $(".object_wrapper  .field").click(() => {
    $('.object_dropdown_wrapper').toggleClass("open");
  });
  $(document).click((event) => {
    if (!$(event.target).closest('.object_dropdown_wrapper').length && !$(event.target).closest('.object_wrapper .field').length) {
      if ($('.object_dropdown_wrapper').is(":visible")) {
        $('.object_dropdown_wrapper').removeClass('open');
      }
    }
  });

  $("#range_age").ionRangeSlider({
    type: "double",
    min: 11,
    max: 25,
    from: 15,
    to: 20,
    step: 1
  });
  $("#range_budget").ionRangeSlider({
    type: "double",
    min: 0,
    max: 2500,
    from: 500,
    to: 2000,
    step: 10,
    postfix: " €"
  });

  (function ($) {
    $(() => {
      $('ul.tabs__caption').on('click', 'li:not(.active)', function () {
        $(this)
          .addClass('active').siblings().removeClass('active')
          .closest('div.tabs')
          .children('div.tabs__content')
          .removeClass('active')
          .eq($(this).index())
          .addClass('active');
      });
    });
  }(jQuery));


  $('.accordion').click(function (e) {
    e.preventDefault();
    const $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('.panel').removeClass('show');
      $this.parent().parent().find('.panel').slideUp(350);
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
    }
  });

  $(".modal_body .modal_open").click(function () {
    $(this).parents('.modal_window').first().toggleClass('active');
  });


  $(window).resize(() => {
    if ($(window).width()>992 && $('.nav_wrapper').is(':hidden')) {
      $('.nav_wrapper').slideToggle("fast");
    }
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 25 && $(window).width()>992) {
      $('header').addClass('sticky');
    } else {
      $('header').removeClass('sticky');
    }
  });
}




// WEBPACK FOOTER //
// app/scripts/components/main.js